<template>
    <div class="codics-aonaer-info-sys-user-home-body">
        <div class="codics-aonaer-info-sys-user-home-line">
            <div class="codics-aonaer-info-sys-user-home-card" :data-txt="'宣传画册'" @click="jumpToPage('公司画册', {}, {})"
                style="background: rgba(53, 107, 180, .8);">
                <img src="https://cdn.bosscaigou.com/huayuan/img/yasuo_157505074c4923032be7041bea25d19%20%281%29.webp"
                    alt="">
            </div>
            <div class="codics-aonaer-info-sys-user-home-card" :data-txt="'公司视频'" @click="jumpToPage('公司视频', {}, {})"
                style="background: rgba(114, 177, 49, .75);"
                :style="{ 'width': 'calc(100% - 265px)', 'margin-left': '15px' }">
                <img src="https://cdn.bosscaigou.com/huayuan/img/yasuo_01f34e945d4c707fa1e0d0b10f0926c%20%281%29.webp"
                    alt="">
            </div>
        </div>
        <div class="codics-aonaer-info-sys-user-home-line" style="margin-top: 15px;">
            <div class="codics-aonaer-info-sys-user-home-card" :data-txt="'工厂模型'" @click="jumpToPage('工厂模型', {}, {})"
                style="background: rgba(158, 48, 174, .7);" :style="{ 'width': 'calc(100% - 265px)' }">
                <img class="codics-aonaer-info-sys-user-home-card-img"
                    src="https://cdn.bosscaigou.com/huayuan/img/yasuo_25eaf79bdb80e0ef138cd641e390857.webp" alt="">
            </div>
            <div class="codics-aonaer-info-sys-user-home-card" :data-txt="'节日海报'"
                @click="jumpToPage('公司海报', { year: 2025 }, {})" :style="{ 'margin-left': '15px' }">
                <img src="https://cdn.bosscaigou.com/huayuan/img/yasuo_c61970149a48f9c814d18e455f1ffbf.webp" alt="">
            </div>
        </div>
    </div>
</template>

<script>
import { jumpTo } from '@/utils/myutils';
export default {
    methods: {
        jumpToPage(n, p, q) {
            jumpTo(this, n, p, q);
        }
    }
}
</script>

<style>
.codics-aonaer-info-sys-user-home-body {
    height: fit-content;
    width: 100%;
    position: relative;
    float: left;
    background: #f3f3f3;
}

.codics-aonaer-info-sys-user-home-line {
    height: 250px;
    width: 100%;
    position: relative;
    float: left;
    box-sizing: border-box;
}

.codics-aonaer-info-sys-user-home-card {
    height: 100%;
    width: 250px;
    position: relative;
    float: left;
    background: #EA5B18;
    box-sizing: border-box;
    transition: .3s;
    cursor: pointer;
    overflow: hidden;
}

.codics-aonaer-info-sys-user-home-card::before {
    content: attr(data-txt);
    height: 30px;
    width: fit-content;
    position: absolute;
    margin: auto;
    top: 20px;
    left: 20px;
    line-height: 30px;
    font-size: 18px;
    color: #333;
    letter-spacing: 3px;
    border-top: 1.5px solid #333;
    box-sizing: border-box;
    z-index: 111;
    font-weight: 500;
}

.codics-aonaer-info-sys-user-home-card img {
    height: 100%;
    width: 100%;
    position: absolute;
    margin: auto;
    top: 0;
    left: 0;
    box-sizing: border-box;
    object-fit: cover;
    transition: .3s;
}

/* .codics-aonaer-info-sys-user-home-card:hover {} */

.codics-aonaer-info-sys-user-home-card:hover img {
    transform: scale(1.1);
    filter: blur(8px);
}

/* .codics-aonaer-info-sys-user-home-card-img {
    height: 200px !important;
    width:300px !important;
    position: absolute !important;
    margin: auto !important;
    top: 25px !important;
    right: 25px !important;
    box-sizing: border-box !important;
    object-fit: fill !important;
    transition: .3s !important;
} */
</style>